export default "__VITE_PUBLIC_ASSET__aabd1b0a__"